/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Column_EnabledInputs */

const id_tld_pricing_column_enabled = /** @type {(inputs: Tld_Pricing_Column_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif`)
};

const en_tld_pricing_column_enabled = /** @type {(inputs: Tld_Pricing_Column_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable`)
};

/**
* | output |
* | --- |
* | "Enable" |
*
* @param {Tld_Pricing_Column_EnabledInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_column_enabled = /** @type {((inputs?: Tld_Pricing_Column_EnabledInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Column_EnabledInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_column_enabled(inputs)
	return id_tld_pricing_column_enabled(inputs)
});